import { CtModelRouteData } from "@ctsolution/ct-framework";

/**
 * Route-data per il controller `leadinformation`.
 * Analogo a `company-information.route-data.ts`.
 */
export const LeadInformationRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("leadinformation");
